import { useState } from "react";
import ErrorComponent from "@/components/empty/ErrorComponent";
import LoadingBackdrop from "@/components/loadingBackdrop/LoadingBackdrop";
import Tabs from "@/components/Tabs";
import Template3Column from "@/components/templates/author/Template3Column";
import useRecentArticles from "@/utils/hooks/useRecentArticles";
import useSports from "@/utils/hooks/useSports";
import styles from "./authorContainer.module.scss";

const AuthorContainer = () => {
  const { selectableSportsForAuthors } = useSports();
  const [selectedSport, setSport] = useState(
    selectableSportsForAuthors[0]?.name
  );
  const {
    articles = [],
    isLoading,
    isFetching,
    isError,
  } = useRecentArticles({
    sportName: selectedSport || undefined,
    hideDeprioritizedContent: true,
    limit: 15,
  });

  const loading = isLoading || isFetching;
  const success = !isFetching && articles && articles.length > 0;
  const [col1Articles, col2Articles, col3Articles] = [
    articles.slice(0, 5),
    articles.slice(5, 10),
    articles.slice(10, 15),
  ];

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>More from our authors</h3>
      <div className={styles.tabsContainer}>
        <Tabs
          dataTestId="sports-tabs"
          items={selectableSportsForAuthors.map(({ name }) => name)}
          selected={selectedSport}
          setSelected={setSport}
        />
      </div>
      <div className={styles.cardContent}>
        <LoadingBackdrop loading={loading} />
        {isError && <ErrorComponent ctaButtonLabel="Refresh Module" />}
        {success && (
          <Template3Column
            col1Articles={col1Articles}
            col2Articles={col2Articles}
            col3Articles={col3Articles}
          />
        )}
      </div>
    </div>
  );
};

export default AuthorContainer;
